export const aboutRoutes = {
  CONTACTS_INFO: "/club/contacts",
};